import MiCheckbox from './MiCheckbox.vue'

export default MiCheckbox
